// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__xw+3V","Breadcrumbs-item":"Breadcrumbs_Breadcrumbs-item__aXXkj"};